import React from "react";
import { MinistriesComp } from "../../components/ministries/ministriescomponent";

const Ministries = () => {

    return(
        
        <>
            <MinistriesComp />
        </>
    )
}

export default Ministries;